var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "e-howto-row" }, [
    _c(
      "div",
      {
        staticClass: "e-howto-title",
        class: { "m-active": _vm.isOpen },
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.toggleHandler($event)
          }
        }
      },
      [_vm._v("\n        " + _vm._s(_vm.howto.label) + "\n    ")]
    ),
    _vm._v(" "),
    _c("div", {
      staticClass: "e-howto-data",
      class: { "m-active": _vm.isOpen },
      domProps: { innerHTML: _vm._s(_vm.howto.body) }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }